import { type ConsoleUser, findUserOrganization } from '@/stores/auth'
import type { BillingStatus, Plan, SubscriptionState } from '@/types/subscription'
import { periodToBillingCycle, subscriptionStateToStatus } from '@/utils/subscriptionHelpers'
import { consoleApiCall } from './axiosInstance'

export const billingApi = {
	getPlans: async (organizationId: string): Promise<Plan[]> => {
		const response = await consoleApiCall<{ result: Plan[] }>(
			`/v1/organizations/${encodeURIComponent(organizationId)}/plans`,
		)
		return response.result || []
	},
	getPublicPlans: async (): Promise<Plan[]> => {
		const response = await consoleApiCall<{ result: Plan[] }>('/v1/plans')
		return response.result || []
	},
	getCurrentUserWithSubscription: async (): Promise<ConsoleUser> => {
		return consoleApiCall<ConsoleUser>('/v1/me')
	},
	getBillingStatusFromUser: (user: ConsoleUser, organizationId?: string | null): BillingStatus | null => {
		const organization = findUserOrganization(user, organizationId) ?? user.organizations?.[0]

		const subscription = organization?.subscription

		if (!subscription) {
			return null
		}

		return {
			email: user.email,
			current_plan: subscription.plan_name || '',
			billing_frequency: periodToBillingCycle(subscription.period as 'Yearly' | 'Monthly'),
			subscription_status: subscriptionStateToStatus(subscription.state as SubscriptionState),
			subscription_state: subscription.state as SubscriptionState,
			next_billing_date: subscription.expires_at,
			payment_method_status: subscription.state === 'pending_initial_payment' ? 'pending' : 'active',
		}
	},
}
